import { UserContainer, UserRegister } from '@User/Data/DataSource/Container'
import { DBUser } from '@User/Domain/Model/User'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

export const useUserManager = () => {
    const userUseCase = UserContainer.get(UserRegister.UseCaseGetUser)
    const userUpdateUseCase = UserContainer.get(UserRegister.UseCaseUpdateUser)
    const userDisableUseCase = UserContainer.get(
        UserRegister.UseCaseDisableUser
    )
    const userEnableUseCase = UserContainer.get(UserRegister.UseCaseEnableUser)
    const [user, setUser] = useState<DBUser | null>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const { id } = useParams()

    const handleChange = (e: React.ChangeEvent<any>) => {
        const key = e.target.name
        const value = e.target.value
        setUser(
            (prev: DBUser | null): DBUser | null =>
                ({
                    ...prev,
                    [key]: value,
                } as DBUser)
        )
    }

    const getUser = async (id: string) => {
        setLoading(true)
        try {
            const data = await userUseCase.execute(id)
            setUser(data)
        } catch (error) {
            console.error(error)
        }
        setLoading(false)
    }

    const handleChangePermission = (e: React.ChangeEvent<any>) => {
        const roleKey = e.target.name
        const roleValue = e.target.checked
        if (roleValue) {
            setUser(
                (prev: DBUser | null): DBUser | null =>
                    ({
                        ...prev,
                        // @ts-ignore
                        roles: [...prev?.roles, roleKey],
                    } as DBUser)
            )
        }
        if (!roleValue) {
            setUser(
                (prev: DBUser | null): DBUser | null =>
                    ({
                        ...prev,
                        roles: [
                            // @ts-ignore
                            ...prev.roles.filter((role) => role !== roleKey),
                        ],
                    } as DBUser)
            )
        }
    }

    const handleSave = async () => {
        setLoading(true)
        try {
            const updatedUser = await userUpdateUseCase.execute(user as DBUser)
            setUser(updatedUser)
            toast.success('Usuário atualizado com sucesso')
        } catch (error) {
            console.error(error)
            toast.error('Erro ao atualizar usuário')
        }
        setLoading(false)
    }

    const handleDisable = async () => {
        if (!user?.uid) {
            toast.error('Usuário não encontrado')
            return
        }
        setLoading(true)
        try {
            await userDisableUseCase.execute(user?.mail)
            toast.success('Usuário desativado com sucesso')
            // Recarregar os dados do usuário para refletir o novo status
            await getUser(user.mail)
        } catch (error) {
            console.error(error)
            toast.error('Erro ao desativar usuário')
        }
        setLoading(false)
    }

    const handleEnable = async () => {
        if (!user?.uid) {
            toast.error('Usuário não encontrado')
            return
        }
        setLoading(true)
        try {
            await userEnableUseCase.execute(user?.mail)
            toast.success('Usuário ativado com sucesso')
            // Recarregar os dados do usuário para refletir o novo status
            await getUser(user.mail)
        } catch (error) {
            console.error(error)
            toast.error('Erro ao ativar usuário')
        }
        setLoading(false)
    }

    useEffect(() => {
        if (id) getUser(id)
    }, [id])

    const reloadUser = async () => {
        if (user?.mail) await getUser(user.mail)
    }

    return {
        user,
        loading,
        reloadUser,
        handleChangePermission,
        handleSave,
        handleChange,
        handleDisable,
        handleEnable,
    }
}
